import React from "react"
import { Link } from "gatsby"
import { Wrapper, Text, HeartIcon, CodeIcon } from "./style"

const Footer = () => (
  <Wrapper>
    <Text>
      <span>
        © {new Date().getFullYear()} - <Link to="/">raellage.github.io</Link>
      </span>
      <br /><br />
      <span>
        Built with <HeartIcon /> and
        {` `}
        <CodeIcon alt="and 1 more Javascript Framework :D" />
      </span>
    </Text>
  </Wrapper>
)

export default Footer
